import MasterSerive from "./MasterService";

const InsuranceIdService = {
    ...MasterSerive,

    getLeadDetail(params: object) {
        return this.post('/lead/leadDetails', params)
    },
    getAgentPoints(params:object){
        return this.post('/agency/getAgentPoints', params)
    },
    getAgentComChangeList(params:object){
        return this.post('/agency/getAgentComChangeList', params)
    },
    cancelRequest(params:object){
        return this.post('/agency/cancelRequest', params)
    },
    saveAgentDetails(params:object){
        return this.post('/agency/saveAgentDetails', params)
    },
    getAgentleadHistory(params:object){
        return this.post('/agency/getAgentleadHistory', params)
    },
    agentPointStatus(params:object){
        return this.post('/agency/agentPointStatus', params)
    },
    getEstimatedCarPrice(params:object){
        return this.post('/lead/get-estimated-car-price', params)
    }
}

export default InsuranceIdService;